import { render, staticRenderFns } from "./ListPrintLabel.vue?vue&type=template&id=38ebd6b9"
import script from "./ListPrintLabel.vue?vue&type=script&lang=js"
export * from "./ListPrintLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports